import { PhoneCall, Mail, MapPin, Clock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, COMPANY } from "@/lib/site-content";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-zinc-50 py-20 sm:py-28 lg:py-32 border-b border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="max-w-3xl mb-12">
          <p className="label-eyebrow mb-4">Contact</p>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-zinc-900 leading-[1.02] tracking-tighter">
            One number.
            <br />
            <span className="text-[#FF4500]">Every utility question.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          <a
            href={PHONE_TEL}
            data-testid="contact-phone-card"
            className="group bg-white border border-zinc-200 hover:border-[#FF4500] p-8 transition-all hover:-translate-y-1 hover:shadow-xl"
          >
            <div className="w-12 h-12 bg-[#FF4500] flex items-center justify-center mb-5">
              <PhoneCall className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <p className="label-eyebrow mb-2">Call us</p>
            <p className="font-display font-black text-2xl tracking-tight text-zinc-900 group-hover:text-[#FF4500] transition-colors">
              {PHONE_DISPLAY}
            </p>
            <p className="mt-2 text-sm text-zinc-500">Tap to call now</p>
          </a>

          <div className="bg-white border border-zinc-200 p-8">
            <div className="w-12 h-12 bg-zinc-900 flex items-center justify-center mb-5">
              <Clock className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <p className="label-eyebrow mb-2">Hours</p>
            <p className="font-display font-bold text-xl tracking-tight text-zinc-900">
              24/7 Live Support
            </p>
            <p className="mt-2 text-sm text-zinc-500">Including holidays</p>
          </div>

          <div className="bg-white border border-zinc-200 p-8">
            <div className="w-12 h-12 bg-zinc-900 flex items-center justify-center mb-5">
              <MapPin className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <p className="label-eyebrow mb-2">Service area</p>
            <p className="font-display font-bold text-xl tracking-tight text-zinc-900">
              All 50 States
            </p>
            <p className="mt-2 text-sm text-zinc-500">United States</p>
          </div>

          <div className="bg-white border border-zinc-200 p-8">
            <div className="w-12 h-12 bg-zinc-900 flex items-center justify-center mb-5">
              <Mail className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <p className="label-eyebrow mb-2">Online</p>
            <p className="font-display font-bold text-xl tracking-tight text-zinc-900">
              Request Form
            </p>
            <a
              href="#request"
              className="mt-2 inline-block text-sm text-[#FF4500] font-semibold hover:underline"
            >
              Send a request →
            </a>
          </div>
        </div>

        <div className="mt-12 bg-zinc-900 text-white p-8 sm:p-12 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
          <div>
            <p className="label-eyebrow text-zinc-400 mb-2">Stop scrolling</p>
            <p className="font-display font-black text-3xl sm:text-4xl tracking-tight">
              Talk to a {COMPANY.split(" ")[0]} specialist now.
            </p>
          </div>
          <a
            href={PHONE_TEL}
            data-testid="contact-final-call-button"
            className="inline-flex items-center justify-center gap-3 bg-[#FF4500] hover:bg-[#E63E00] text-white font-display font-black px-8 py-5 text-lg transition-all active:scale-[0.97] whitespace-nowrap"
          >
            <PhoneCall className="w-5 h-5" strokeWidth={2.7} />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
